import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { devLog } from '../Util/_HumanWritten/ConsoleLogUtils';

export const usePreventBackFrom = (blockedFromPath: string, shouldBlock: boolean) => {
	const location = useLocation();

	useEffect(() => {
		const isOnPage = location.pathname === blockedFromPath;
		const shouldBlockNow = shouldBlock && isOnPage;

		if (!shouldBlockNow) return;

		// Push a dummy state to prevent back navigation
		const pushDummyState = () => {
			window.history.pushState(null, '', location.pathname);
		};

		// Handle popstate (back/forward button)
		const handlePopState = (event: PopStateEvent) => {
			// Immediately push the current state again to "cancel" the back navigation
			window.history.pushState(null, '', blockedFromPath);

			// Provide user feedback
			devLog('Back navigation prevented - please use the navigation buttons in the app');
		};

		// Set up the blocking
		pushDummyState();
		window.addEventListener('popstate', handlePopState);

		return () => {
			window.removeEventListener('popstate', handlePopState);
		};
	}, [shouldBlock, location.pathname]);
};
